var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef5323;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone-call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-1",
    d: "M9.88,8.27l-2-.91a1.06,1.06,0,0,0-1.25.3L6,8.39A7.93,7.93,0,0,1,3.6,6l.73-.59a1,1,0,0,0,.3-1.24l-.9-2a1,1,0,0,0-1.22-.59L.79,2A1.06,1.06,0,0,0,0,3.15,10.44,10.44,0,0,0,8.85,12,1.06,1.06,0,0,0,10,11.21l.45-1.72A1,1,0,0,0,9.88,8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-1",
    d: "M12,6H10.5A4.51,4.51,0,0,0,6,1.5V0A6,6,0,0,1,12,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-1",
    d: "M9,6H7.5A1.5,1.5,0,0,0,6,4.5V3A3,3,0,0,1,9,6Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.43de0d3ba778377405223226316d6b44.svg";
export { ForwardRef as ReactComponent };